import { getBookedTimesForDate } from './availabilityService';

/**
 * Get booked time slots for a specific date (public-safe, no PII).
 */
export const getBookedSlots = async (date) => {
  try {
    const bookedTimes = await getBookedTimesForDate(date);
    return bookedTimes.map((time) => ({ time, appointment: null }));
  } catch (error) {
    console.error('Error getting booked slots:', error);
    return [];
  }
};

/**
 * Check if a specific time slot is booked
 */
export const isTimeSlotBooked = async (date, time) => {
  try {
    const bookedSlots = await getBookedSlots(date);
    return bookedSlots.some((slot) => slot.time === time) ? { time } : null;
  } catch (error) {
    console.error('Error checking time slot:', error);
    return null;
  }
};

/**
 * Get available time slots for a date
 */
export const getAvailableTimeSlots = async (date) => {
  try {
    const targetDate = date instanceof Date ? date : new Date(date);
    const dayOfWeek = targetDate.getDay();

    const allSlots = [];
    const startHour = 8;
    const endHour = dayOfWeek === 6 ? 18 : 20;

    for (let hour = startHour; hour < endHour; hour += 1) {
      for (let minute = 0; minute < 60; minute += 30) {
        allSlots.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
      }
    }

    const bookedSlots = await getBookedSlots(date);
    const bookedTimes = bookedSlots.map((slot) => slot.time);
    return allSlots.filter((slot) => !bookedTimes.includes(slot));
  } catch (error) {
    console.error('Error getting available time slots:', error);
    return [];
  }
};

export const isDateInPast = (date) => {
  const targetDate = date instanceof Date ? date : new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  targetDate.setHours(0, 0, 0, 0);
  return targetDate < today;
};

export const isTimeSlotInPast = (date, time) => {
  const targetDate = date instanceof Date ? date : new Date(date);
  const [hours, minutes] = time.split(':').map(Number);
  const slotDateTime = new Date(targetDate);
  slotDateTime.setHours(hours, minutes, 0, 0);
  return slotDateTime < new Date();
};

export const formatTimeForDisplay = (time) => {
  const [hours, minutes] = time.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);
  return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
};

// Legacy export — admin calendar still uses appointmentService directly
export { getBookedTimesForDate } from './availabilityService';
